import React from "react";
import { useMsal } from "@azure/msal-react";
import getClassNames from "../../Utils/getClassNames";
import Button from "./Button";

function handleLogout(instance) {
	instance.logoutRedirect().catch(e => {
		console.error(e);
	});
}

export const SignOutButton = (props) => {
	const { instance } = useMsal();

	return (
		<>
			<Button className={getClassNames('btn-secondary', props.className)}
				onClick={() => handleLogout(instance)}
				text="Sign Out"
				id="sign-out-button" />
		</>
	);
}